<template>
    <v-card>
        Not Found
    </v-card>
</template>
<script>
export default {
    
}
</script>